// URL Regex supports the examples below
// https://example.com/api, https://www.example.com/api, http://localhost:3000/api, https://111.22.332.2:8080/api
export const urlRegex = /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?(?![^<]*(?:<\/\w+>|\/?>))/
